module.exports = __webpack_public_path__ + "img/huxi_des_2.979ef91c.jpg";